import { render, staticRenderFns } from "./pacientes.vue?vue&type=template&id=91127646&"
import script from "./pacientes.vue?vue&type=script&lang=js&"
export * from "./pacientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports